module.exports = __webpack_public_path__ + "static/media/16th_D.fd72d509.png";